import RemoveCircle from 'assets/icons/RemoveCircle'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Pagination } from 'components/Pagination/Pagination'
import { setConfirmModal } from 'features/global/globalSlice'
import { clearRolePermssionPolicyList, deleteRolePermissionPolicy, getRolePermissionPolicies } from 'features/roles/clientRolesSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, GridItem, H1WithBack, ItemsGrid, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { ModalTypes } from 'types/global.interface'
import { getParams, handlePagination } from 'utils/helpers'

export const RolePermissionPolicies = () => {
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { permissionPolicies } = useSelector((state: RootState) => state.clientRoles)
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()

    useQueryPagination({ fetchFunctions: [getRolePermissionPolicies], cleanUpFunctions: [clearRolePermssionPolicyList], params })

    const removePolicy = (id: number, e) => {
        e.stopPropagation()
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteRolePermissionPolicy(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                },
                word: 'delete policy',
            }),
        )
    }

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <H1WithBack arrow title='Permission Policies' />
                <Button orange onClick={() => navigate('add')}>
                    Add Policy
                </Button>
            </Flex>
            <ItemsGrid columns={3} mt='25px'>
                {permissionPolicies?.data.length ? permissionPolicies.data.map(({ policyName, id }) => {
                    return (
                        <GridItem key={id} onClick={() => navigate(id.toString())}>
                            <p>
                                {policyName}
                            </p>

                            <Flex between center onClick={(e) => removePolicy(id, e)}>
                                <RemoveCircle />
                            </Flex>
                        </GridItem>
                    )
                })
                    : (
                        <NoData />
                    )}
            </ItemsGrid>

        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams)}
                pageCount={Math.ceil(permissionPolicies.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}